export default __webpack_public_path__ + "static/media/icons8-spring-boot-48.b39d866e.svg";